import IPData from 'ipdata'
const cacheConfig = {
  max: 1000, // max size
  maxAge: 10 * 60 * 1000, // max age in ms (i.e. 10 minutes)
}
const ipdata = new IPData(
  'ffa0716a3c72de6001b03f53407478a6753f288bb3d2d40cf3acf559',
  cacheConfig
)

class CountrySelector extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    // Function to populate the country selector dropdown
    const populateCountrySelector = (countryCode) => {
      const countrySelector = this.querySelector('#country')

      // Set the selected option based on the countryCode
      for (let i = 0; i < countrySelector.options.length; i++) {
        if (countrySelector.options[i].value === countryCode) {
          countrySelector.selectedIndex = i
          break
        }
      }
    }

    if (this.querySelector('#country')) {
      // Check if the URL contains a country code
      const url = window.location.pathname
      const countryCodes = {
        '/en-ca': 'Canada',
        '/en-mx': 'Mexico',
        '/en-af': 'Afghanistan',
        '/en-ax': 'Aland Islands',
        '/en-al': 'Albania',
        '/en-dz': 'Algeria',
        '/en-as': 'American Samoa',
        '/en-ad': 'Andorra',
        '/en-ao': 'Angola',
        '/en-ai': 'Anguilla',
        '/en-aq': 'Antarctica',
        '/en-ag': 'Antigua and Barbuda',
        '/en-ar': 'Argentina',
        '/en-am': 'Armenia',
        '/en-aw': 'Aruba',
        '/en-au': 'Australia',
        '/en-at': 'Austria',
        '/en-az': 'Azerbaijan',
        '/en-bs': 'Bahamas',
        '/en-bh': 'Bahrain',
        '/en-bd': 'Bangladesh',
        '/en-bb': 'Barbados',
        '/en-by': 'Belarus',
        '/en-be': 'Belgium',
        '/en-bz': 'Belize',
        '/en-bj': 'Benin',
        '/en-bm': 'Bermuda',
        '/en-bt': 'Bhutan',
        '/en-bo': 'Bolivia',
        '/en-bq': 'Bonaire, Sint Eustatius and Saba',
        '/en-ba': 'Bosnia and Herzegovina',
        '/en-bw': 'Botswana',
        '/en-bv': 'Bouvet Island',
        '/en-br': 'Brazil',
        '/en-io': 'British Indian Ocean Territory',
        '/en-bn': 'Brunei Darussalam',
        '/en-bg': 'Bulgaria',
        '/en-bf': 'Burkina Faso',
        '/en-bi': 'Burundi',
        '/en-kh': 'Cambodia',
        '/en-cm': 'Cameroon',
        '/en-ca': 'Canada',
        '/en-cv': 'Cape Verde',
        '/en-ky': 'Cayman Islands',
        '/en-cf': 'Central African Republic',
        '/en-td': 'Chad',
        '/en-cl': 'Chile',
        '/en-cn': 'China',
        '/en-cx': 'Christmas Island',
        '/en-cc': 'Cocos (Keeling) Islands',
        '/en-co': 'Colombia',
        '/en-km': 'Comoros',
        '/en-cg': 'Congo',
        '/en-cd': 'Congo, Democratic Republic of the Congo',
        '/en-ck': 'Cook Islands',
        '/en-cr': 'Costa Rica',
        '/en-ci': "Cote D'Ivoire",
        '/en-hr': 'Croatia',
        '/en-cu': 'Cuba',
        '/en-cw': 'Curacao',
        '/en-cy': 'Cyprus',
        '/en-cz': 'Czech Republic',
        '/en-dk': 'Denmark',
        '/en-dj': 'Djibouti',
        '/en-dm': 'Dominica',
        '/en-do': 'Dominican Republic',
        '/en-ec': 'Ecuador',
        '/en-eg': 'Egypt',
        '/en-sv': 'El Salvador',
        '/en-gq': 'Equatorial Guinea',
        '/en-er': 'Eritrea',
        '/en-ee': 'Estonia',
        '/en-et': 'Ethiopia',
        '/en-fk': 'Falkland Islands (Malvinas)',
        '/en-fo': 'Faroe Islands',
        '/en-fj': 'Fiji',
        '/en-fi': 'Finland',
        '/en-fr': 'France',
        '/en-gf': 'French Guiana',
        '/en-pf': 'French Polynesia',
        '/en-tf': 'French Southern Territories',
        '/en-ga': 'Gabon',
        '/en-gm': 'Gambia',
        '/en-ge': 'Georgia',
        '/en-de': 'Germany',
        '/en-gh': 'Ghana',
        '/en-gi': 'Gibraltar',
        '/en-gr': 'Greece',
        '/en-gl': 'Greenland',
        '/en-gd': 'Grenada',
        '/en-gp': 'Guadeloupe',
        '/en-gu': 'Guam',
        '/en-gt': 'Guatemala',
        '/en-gg': 'Guernsey',
        '/en-gn': 'Guinea',
        '/en-gw': 'Guinea-Bissau',
        '/en-gy': 'Guyana',
        '/en-ht': 'Haiti',
        '/en-hm': 'Heard Island and Mcdonald Islands',
        '/en-va': 'Holy See (Vatican City State)',
        '/en-hn': 'Honduras',
        '/en-hk': 'Hong Kong',
        '/en-hu': 'Hungary',
        '/en-is': 'Iceland',
        '/en-in': 'India',
        '/en-id': 'Indonesia',
        '/en-ir': 'Iran, Islamic Republic of',
        '/en-iq': 'Iraq',
        '/en-ie': 'Ireland',
        '/en-im': 'Isle of Man',
        '/en-il': 'Israel',
        '/en-it': 'Italy',
        '/en-jm': 'Jamaica',
        '/en-jp': 'Japan',
        '/en-je': 'Jersey',
        '/en-jo': 'Jordan',
        '/en-kz': 'Kazakhstan',
        '/en-ke': 'Kenya',
        '/en-ki': 'Kiribati',
        '/en-kp': "Korea, Democratic People's Republic of",
        '/en-kr': 'Korea, Republic of',
        '/en-xk': 'Kosovo',
        '/en-kw': 'Kuwait',
        '/en-kg': 'Kyrgyzstan',
        '/en-la': "Lao People's Democratic Republic",
        '/en-lv': 'Latvia',
        '/en-lb': 'Lebanon',
        '/en-ls': 'Lesotho',
        '/en-lr': 'Liberia',
        '/en-ly': 'Libyan Arab Jamahiriya',
        '/en-li': 'Liechtenstein',
        '/en-lt': 'Lithuania',
        '/en-lu': 'Luxembourg',
        '/en-mo': 'Macao',
        '/en-mk': 'Macedonia, the Former Yugoslav Republic of',
        '/en-mg': 'Madagascar',
        '/en-mw': 'Malawi',
        '/en-my': 'Malaysia',
        '/en-mv': 'Maldives',
        '/en-ml': 'Mali',
        '/en-mt': 'Malta',
        '/en-mh': 'Marshall Islands',
        '/en-mq': 'Martinique',
        '/en-mr': 'Mauritania',
        '/en-mu': 'Mauritius',
        '/en-yt': 'Mayotte',
        '/en-mx': 'Mexico',
        '/en-fm': 'Micronesia, Federated States of',
        '/en-md': 'Moldova, Republic of',
        '/en-mc': 'Monaco',
        '/en-mn': 'Mongolia',
        '/en-me': 'Montenegro',
        '/en-ms': 'Montserrat',
        '/en-ma': 'Morocco',
        '/en-mz': 'Mozambique',
        '/en-mm': 'Myanmar',
        '/en-na': 'Namibia',
        '/en-nr': 'Nauru',
        '/en-np': 'Nepal',
        '/en-nl': 'Netherlands',
        '/en-an': 'Netherlands Antilles',
        '/en-nc': 'New Caledonia',
        '/en-nz': 'New Zealand',
        '/en-ni': 'Nicaragua',
        '/en-ne': 'Niger',
        '/en-ng': 'Nigeria',
        '/en-nu': 'Niue',
        '/en-nf': 'Norfolk Island',
        '/en-mp': 'Northern Mariana Islands',
        '/en-no': 'Norway',
        '/en-om': 'Oman',
        '/en-pk': 'Pakistan',
        '/en-pw': 'Palau',
        '/en-ps': 'Palestinian Territory, Occupied',
        '/en-pa': 'Panama',
        '/en-pg': 'Papua New Guinea',
        '/en-py': 'Paraguay',
        '/en-pe': 'Peru',
        '/en-ph': 'Philippines',
        '/en-pn': 'Pitcairn',
        '/en-pl': 'Poland',
        '/en-pt': 'Portugal',
        '/en-pr': 'Puerto Rico',
        '/en-qa': 'Qatar',
        '/en-re': 'Reunion',
        '/en-ro': 'Romania',
        '/en-ru': 'Russian Federation',
        '/en-rw': 'Rwanda',
        '/en-bl': 'Saint Barthelemy',
        '/en-sh': 'Saint Helena',
        '/en-kn': 'Saint Kitts and Nevis',
        '/en-lc': 'Saint Lucia',
        '/en-mf': 'Saint Martin',
        '/en-pm': 'Saint Pierre and Miquelon',
        '/en-vc': 'Saint Vincent and the Grenadines',
        '/en-ws': 'Samoa',
        '/en-sm': 'San Marino',
        '/en-st': 'Sao Tome and Principe',
        '/en-sa': 'Saudi Arabia',
        '/en-sn': 'Senegal',
        '/en-rs': 'Serbia',
        '/en-cs': 'Serbia and Montenegro',
        '/en-sc': 'Seychelles',
        '/en-sl': 'Sierra Leone',
        '/en-sg': 'Singapore',
        '/en-sx': 'Sint Maarten',
        '/en-sk': 'Slovakia',
        '/en-si': 'Slovenia',
        '/en-sb': 'Solomon Islands',
        '/en-so': 'Somalia',
        '/en-za': 'South Africa',
        '/en-gs': 'South Georgia and the South Sandwich Islands',
        '/en-ss': 'South Sudan',
        '/en-es': 'Spain',
        '/en-lk': 'Sri Lanka',
        '/en-sd': 'Sudan',
        '/en-sr': 'Suriname',
        '/en-sj': 'Svalbard and Jan Mayen',
        '/en-sz': 'Swaziland',
        '/en-se': 'Sweden',
        '/en-ch': 'Switzerland',
        '/en-sy': 'Syrian Arab Republic',
        '/en-tw': 'Taiwan, Province of China',
        '/en-tj': 'Tajikistan',
        '/en-tz': 'Tanzania, United Republic of',
        '/en-th': 'Thailand',
        '/en-tl': 'Timor-Leste',
        '/en-tg': 'Togo',
        '/en-tk': 'Tokelau',
        '/en-to': 'Tonga',
        '/en-tt': 'Trinidad and Tobago',
        '/en-tn': 'Tunisia',
        '/en-tr': 'Turkey',
        '/en-tm': 'Turkmenistan',
        '/en-tc': 'Turks and Caicos Islands',
        '/en-tv': 'Tuvalu',
        '/en-ug': 'Uganda',
        '/en-ua': 'Ukraine',
        '/en-ae': 'United Arab Emirates',
        '/en-gb': 'United Kingdom',
        '/en-us': 'United States',
        '/en-um': 'United States Minor Outlying Islands',
        '/en-uy': 'Uruguay',
        '/en-uz': 'Uzbekistan',
        '/en-vu': 'Vanuatu',
        '/en-ve': 'Venezuela',
        '/en-vn': 'Viet Nam',
        '/en-vg': 'Virgin Islands, British',
        '/en-vi': 'Virgin Islands, U.s.',
        '/en-wf': 'Wallis and Futuna',
        '/en-eh': 'Western Sahara',
        '/en-ye': 'Yemen',
        '/en-zm': 'Zambia',
        '/en-zw': 'Zimbabwe',
      }

      const countryCode = countryCodes[url]

      if (countryCode) {
        // Call the function to populate the country selector dropdown with the associated country
        populateCountrySelector(countryCode)
      } else {
        // If the associated country is not found, use the existing API logic
        fetch('https://api.ipify.org/?format=json')
          .then((response) => response.json())
          .then((data) => {
            const ipAddress = data.ip

            // Fetch country information based on the IP address using iplookup
            ipdata
              .lookup(ipAddress)
              .then((data) => {
                const countryCode = data.country_name

                // Call the function to populate the country selector dropdown
                populateCountrySelector(countryCode)
              })
              .catch((error) => {
                console.error('Error:', error)
              })
          })
          .catch((error) => {
            console.error('Error:', error)
          })
      }
    }
  }
}

customElements.define('country-selector', CountrySelector)
